import {EnvironmentAdmin} from 'compob2b-libs';

export class EnvironmentAdminProd extends EnvironmentAdmin {
  production = true;
  serviceWorkers = true;
  enableWorkflowButton = false;
  serverPicturesPath = 'https://lim-holding.compo-soft.ru/pictures';
  serverDocumentsPath = 'https://lim-holding.compo-soft.ru/documents';
  serverApi =  'https://lim-holding.compo-soft.ru/api/v1';
  serverUrl =  'https://lim-holding.compo-soft.ru';
  impersonate = false;
  impersonatePortalPath = 'https://lim-holding.compo-soft.ru/cabinet/dashboard';
  accessRolesCatalog = true;
}

export const environment = new EnvironmentAdminProd();
